import { render, staticRenderFns } from "./BtnPairs.vue?vue&type=template&id=63c6e155&scoped=true&"
import script from "./BtnPairs.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BtnPairs.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BtnPairs.vue?vue&type=style&index=0&id=63c6e155&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6e155",
  null
  
)

export default component.exports